import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { formatDate, stringToUpperCase } from "../../../../components/Helper";

export const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingTop: 60,
    paddingBottom: 50,
    fontFamily: "HostGrotesk",
    backgroundColor: "white",
  },
  fullpage: {
    margin: 7,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000000",
  },

  sideBySideContainer: { flexDirection: "row" },
  halfWidthRightSection: {
    width: "50%",
    borderBottomWidth: 1,
    borderbottomStyle: "solid",
    borderRightWidth: 1,
    textAlign: "left",
  },
  halfWidthLeftSection: {
    width: "50%",
    borderBottomWidth: 1,
    borderbottomStyle: "solid",
  },
  tableContainer: {},
  tableRow: {
    flexDirection: "row",
    flexGrow: 1,
    paddingLeft: 5,
    paddingRight: 5,
    textAlign: "center",
  },
  tableContent: {
    paddingTop: 1,
    borderRightWidth: 1,
    textAlign: "center",
    justifyContent: "space-between",
  },
  contentPadding: {
    paddingLeft: 5,
    marginRight: 4,
    paddingTop: -1,
  },
  row: {
    flexDirection: "row",
  },
  squareBullet: {
    width: 5,
    height: 5,
    backgroundColor: "black",
    marginLeft: 10,
    marginTop: 5,
  },
  container: {
    paddingTop: 10,
    width: "100%",
    paddingLeft: 5,
  },
  boldText: {
    fontWeight: "bold",
    fontSize: 9,
  },
  smallFontSize: {
    fontSize: 6,
  },
  mediumFontSize: {
    fontSize: 8,
  },
  regularFontSize: {
    fontSize: 9,
  },
  largeFontSize: {
    fontSize: 10,
  },
  subContent: {
    paddingTop: 5,
    paddingLeft: 25,
    paddingRight: 25,
  },
  checkbox: {
    width: 10,
    height: 10,
    borderWidth: 1,
    borderColor: "black",
    marginRight: 10,
  },
  checkMark: {
    fontSize: 18,
    color: "black",
  },
  header: {
    position: "absolute",
    top: -70,
    left: 0,
    right: 0,
    height: 180,
    alignItems: "center",
    fontSize: 12,
    padding: 5,
  },
  footer: {
    position: "absolute",
    bottom: 5,
    left: 0,
    right: 0,
    height: 45,
    alignItems: "center",
    fontSize: 7.5,
    paddingHorizontal: 35,
    textAlign: "center",
  },
  footerText: {
    textAlign: "center",
  },
  footerImage: {
    width: "80%",
    height: "80%",
  },
  headerImage: {
    width: "90%",
    height: "100%",
  },
  logo: {
    height: "60px",
    width: "60px",
  },
  textBlock: { fontSize: 6.7, paddingBottom: 1.5, paddingHorizontal: 3 },
  footerInline: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    textAlign: "center",
  },
});

const VgmCertificate = ({
  salesInvoiceData,
  settingsData,
  companyData,
  includeSignature,
}: {
  salesInvoiceData: any;
  settingsData: any;
  companyData: any;
  includeSignature: boolean;
}) => {
  const staticData = {
    booking_no: "SHMD250008OL",
    weighing_method: "SM-1",
    vgm_wt: "22240.00",
    wt_slip_no: "LE/084",
    tbl_date: "06/01/2025",
    unit: "KG",
    type: "Normal",
  };
  return (
    <Document>
      <Page style={[styles.page]} size="A4">
        <View style={styles.header} fixed>
          {companyData?.invoice_header && (
            <Image
              src={`${process.env.REACT_APP_BACKEND_URL}${companyData?.invoice_header}`}
              style={[
                {
                  width:
                    companyData?.invoice_header_width ||
                    styles.headerImage.width,
                  height:
                    companyData?.invoice_header_height ||
                    styles.headerImage.height,
                },
              ]}
            />
          )}
        </View>
        <View
          style={[styles.sideBySideContainer, { justifyContent: "center" }]}
        >
          <Text style={[styles.boldText, { marginTop: 10 }]}>Annexure - I</Text>
        </View>
        <View
          style={[styles.sideBySideContainer, { justifyContent: "center" }]}
        >
          <Text
            style={[
              styles.boldText,
              { textDecoration: "underline", marginTop: 5 },
            ]}
          >
            INFORMATION ABOUT VERIFIED GROSS MASS OF CONTAINER{" "}
          </Text>
        </View>

        {/* table */}

        {/* table */}
        <View style={{ marginLeft: 10, marginRight: 30, marginTop: 5 }}>
          {/* table header */}
          <View
            style={[
              styles.tableContainer,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                borderTop: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              style={[
                styles.tableRow,
                {
                  textAlign: "left",
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              ></Text>
              <Text
                style={[
                  styles.largeFontSize,
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingBottom: 2,
                  },
                ]}
              >
                Details of Information
              </Text>
              <Text
                style={[
                  styles.largeFontSize,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                Particulars
              </Text>
            </View>
          </View>
          {/* data 1 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                1*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingBottom: 2,
                    paddingLeft: 5,
                  },
                ]}
              >
                Booking No.
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                    paddingBottom: 2,
                    textAlign: "left",
                  },
                ]}
              >
                {stringToUpperCase(staticData.booking_no)}
              </Text>
            </View>
          </View>
          {/* data 2 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                2*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingBottom: 2,
                    paddingLeft: 5,
                  },
                ]}
              >
                Name of the shipper
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                    paddingBottom: 2,
                    textAlign: "left",
                  },
                ]}
              >
                {stringToUpperCase(settingsData?.company_name)}
              </Text>
            </View>
          </View>
          {/* data 3 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                3*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingBottom: 2,
                    paddingLeft: 5,
                  },
                ]}
              >
                Shipper Registration/License No. (IEC No/CIN No)
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                    paddingBottom: 2,
                    textAlign: "left",
                  },
                ]}
              >
                EC No. {stringToUpperCase(settingsData?.iec_no)}
              </Text>
            </View>
          </View>
          {/* data 4 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                4*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingBottom: 4,
                    paddingLeft: 5,
                  },
                ]}
              >
                Name and designation of official of the shipper authorised to
                sign document
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    paddingBottom: 2,
                    width: 380,
                    justifyContent: "space-between",
                    textAlign: "left",
                  },
                ]}
              >
                {stringToUpperCase(settingsData?.name_of_proprietor)}
              </Text>
            </View>
          </View>
          {/* data 5 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                5*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingBottom: 2,
                    paddingLeft: 5,
                  },
                ]}
              >
                24 x 7 contact details of authorised official of shipper
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    paddingRight: 5,
                    paddingBottom: 2,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                    textAlign: "left",
                  },
                ]}
              >
                {settingsData?.company_phone_1},{""}
                {settingsData?.company_phone_2}
              </Text>
            </View>
          </View>

          {/* data 6 */}
          {salesInvoiceData?.containers?.length && (
            <View
              style={[
                styles.tableContainer,
                styles.regularFontSize,
                {
                  textAlign: "left",
                  height: "auto",
                  borderBottom: 1,
                  marginLeft: 30,
                  marginRight: 5,
                  borderRight: 1,
                  borderLeft: 1,
                },
              ]}
            >
              <View
                wrap={false}
                style={[
                  styles.tableRow,
                  {
                    paddingLeft: 5,
                    paddingRight: 5,
                    flexDirection: "row",
                  },
                ]}
              >
                <Text
                  style={[
                    {
                      paddingTop: -1,
                      borderRightWidth: 1,
                      width: 45,
                      justifyContent: "space-between",
                    },
                  ]}
                >
                  6*
                </Text>
                <Text
                  style={[
                    {
                      textAlign: "left",
                      paddingTop: -1,
                      borderRightWidth: 1,
                      width: 400,
                      paddingBottom: 2,
                      justifyContent: "space-between",
                      paddingLeft: 5,
                    },
                  ]}
                >
                  Container No
                </Text>

                <Text
                  style={[
                    styles.boldText,
                    {
                      width: 380,
                      paddingLeft: 5,
                      paddingRight: 5,
                      paddingTop: 2,
                      paddingBottom: 2,
                      textAlign: "left",
                      flexWrap: "wrap",
                    },
                  ]}
                >
                  {salesInvoiceData?.containers
                    ?.map((row: any) => stringToUpperCase(row?.container_no))
                    .join(", ")}
                </Text>
              </View>
            </View>
          )}
          {/* data 7 */}
          {salesInvoiceData?.containers?.length && (
            <View
              style={[
                styles.tableContainer,
                styles.regularFontSize,
                {
                  textAlign: "left",
                  height: "auto",
                  borderBottom: 1,
                  marginLeft: 30,
                  marginRight: 5,
                  borderRight: 1,
                  borderLeft: 1,
                },
              ]}
            >
              <View
                wrap={false}
                style={[
                  styles.tableRow,
                  {
                    paddingLeft: 5,
                    paddingRight: 5,
                    flexDirection: "row",
                  },
                ]}
              >
                <Text
                  style={[
                    {
                      paddingTop: -1,
                      borderRightWidth: 1,
                      width: 45,
                      justifyContent: "space-between",
                    },
                  ]}
                >
                  7*
                </Text>
                <Text
                  style={[
                    {
                      textAlign: "left",
                      paddingTop: -1,
                      borderRightWidth: 1,
                      width: 400,
                      justifyContent: "space-between",
                      paddingLeft: 5,
                      paddingBottom: 2,
                    },
                  ]}
                >
                  Container Size (TEU/FFU/other)
                </Text>
                <Text
                  style={[
                    styles.boldText,
                    {
                      textAlign: "left",
                      paddingRight: 5,
                      paddingTop: -1,
                      paddingLeft: 5,
                      width: 380,
                      paddingBottom: 2,
                      flexWrap: "wrap",
                    },
                  ]}
                >
                  {/*  {salesInvoiceData?.containers
                    ?.map((row: any) => row?.container_no)
                    .join(",")} */}
                  {salesInvoiceData?.containers
                    ?.map((row: any) => row?.size)
                    .join(",")}
                </Text>
              </View>
            </View>
          )}
          {/* data 8 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                8*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingRight: 5,
                    paddingBottom: 2,
                  },
                ]}
              >
                Maximum permissible weight of container as per the CSC plate
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                AS PER BELOW
              </Text>
            </View>
          </View>

          {/* data 9  */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                9*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingRight: 5,
                  },
                ]}
              >
                Weighbridge registration no. & address of weighbridge
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                    paddingBottom: 2,
                  },
                ]}
              >
                REG. NO. APMC BHUJ {"\n"} DHARMADA WEIGH BRIDGE, {"\n"} BHUJ,
                KACHCHH, GUJARAT
              </Text>
            </View>
          </View>

          {/* data 10 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                10*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingBottom: 2,
                    paddingRight: 5,
                  },
                ]}
              >
                Weighing Method (Method-1/Method-2)
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingBottom: 2,
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                {stringToUpperCase(staticData.weighing_method)}
              </Text>
            </View>
          </View>

          {/* data 11 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                11*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingBottom: 2,
                    paddingRight: 5,
                  },
                ]}
              >
                Verified Gross Mass of the Container
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    paddingBottom: 2,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                AS PER BELOW
              </Text>
            </View>
          </View>

          {/* data 12 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                12*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    paddingBottom: 2,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingRight: 5,
                  },
                ]}
              >
                Unit of Measure (KG/MT/LBS)
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingBottom: 2,
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                {staticData.unit}
              </Text>
            </View>
          </View>

          {/* data 13 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                13*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingBottom: 2,
                    paddingRight: 5,
                  },
                ]}
              >
                Date and time of weighing
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingTop: -1,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                AS PER BELOW
              </Text>
            </View>
          </View>

          {/* data 14 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                14*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingTop: -1,
                    borderRightWidth: 1,
                    paddingBottom: 2,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingRight: 5,
                  },
                ]}
              >
                Weighing Slip No
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingBottom: 2,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                AS PER BELOW
              </Text>
            </View>
          </View>

          {/* data 15 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                15*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    paddingBottom: 2,
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingRight: 5,
                  },
                ]}
              >
                Type (Normal/Reefer/Hazardous others)
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingBottom: 2,
                    paddingTop: -1,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                {staticData.type}
              </Text>
            </View>
          </View>

          {/* data 16 */}
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderBottom: 1,
                marginLeft: 30,
                marginRight: 5,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 5,
                  paddingRight: 5,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: 45,
                    justifyContent: "space-between",
                  },
                ]}
              >
                16*
              </Text>
              <Text
                style={[
                  {
                    textAlign: "left",
                    borderRightWidth: 1,
                    width: 400,
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingRight: 5,
                    paddingBottom: 2,
                  },
                ]}
              >
                If Hazardous, UN No, IMDG class
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    width: 380,
                    justifyContent: "space-between",
                  },
                ]}
              >
                NON-HAZARDOUS
              </Text>
            </View>
          </View>
        </View>

        {/* table-2 */}
        {salesInvoiceData?.containers?.length && (
          <View
            style={[
              styles.tableContainer,
              styles.regularFontSize,
              {
                textAlign: "left",
                height: "auto",
                borderTop: 1,
                borderBottom: 1,
                marginLeft: 40,
                marginRight: 30,
                marginTop: 15,
                borderRight: 1,
                borderLeft: 1,
              },
            ]}
          >
            <View
              wrap={false}
              style={[
                styles.tableRow,
                {
                  paddingLeft: 2,
                  paddingRight: 2,
                  flexDirection: "row",
                },
              ]}
            >
              <Text
                style={[
                  styles.boldText,
                  {
                    paddingTop: -1,
                    borderRightWidth: 1,
                    width: "15%",
                    paddingBottom: 2,
                    justifyContent: "space-between",
                  },
                ]}
              >
                SR NO.
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    borderRightWidth: 1,
                    width: "60%",
                    justifyContent: "space-between",
                    paddingLeft: 5,
                    paddingRight: 5,
                    paddingBottom: 10,
                  },
                ]}
              >
                CONTAINER NO
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingBottom: 2,

                    paddingLeft: 5,
                    width: "65%",
                    justifyContent: "space-between",
                  },
                ]}
              >
                SIZE (TEU/FEU)
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    width: "55%",
                    borderLeft: 1,
                    justifyContent: "space-between",
                  },
                ]}
              >
                MAX GROSS
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    textAlign: "left",
                    paddingRight: 5,
                    paddingBottom: 2,

                    paddingLeft: 5,
                    width: "60%",
                    justifyContent: "space-between",
                    borderLeft: 1,
                  },
                ]}
              >
                VGM WT. (KG)
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    borderLeft: 1,
                    textAlign: "left",
                    paddingRight: 5,
                    paddingBottom: 2,

                    paddingLeft: 5,
                    width: "50%",
                    justifyContent: "space-between",
                  },
                ]}
              >
                DATE
              </Text>
              <Text
                style={[
                  styles.boldText,
                  {
                    borderLeft: 1,
                    textAlign: "left",
                    paddingRight: 5,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    width: "50%",
                    justifyContent: "space-between",
                  },
                ]}
              >
                WT. SLIIP NO.
              </Text>
            </View>
          </View>
        )}

        {salesInvoiceData?.containers?.map((row: any, index: number) => {
          return (
            <View
              style={[
                styles.tableContainer,
                styles.regularFontSize,
                {
                  textAlign: "left",
                  height: "auto",
                  borderBottom: 1,
                  marginLeft: 40,
                  marginRight: 30,
                  borderRight: 1,
                  borderLeft: 1,
                },
              ]}
            >
              <View
                wrap={false}
                style={[
                  styles.tableRow,
                  {
                    paddingLeft: 2,
                    paddingRight: 2,
                    flexDirection: "row",
                  },
                ]}
              >
                <Text
                  style={[
                    styles.boldText,
                    {
                      paddingTop: -1,
                      borderRightWidth: 1,
                      width: "15%",
                      justifyContent: "space-between",
                    },
                  ]}
                >
                  {index + 1}
                </Text>
                <Text
                  style={[
                    styles.boldText,
                    {
                      textAlign: "left",
                      borderRightWidth: 1,
                      width: "60%",
                      justifyContent: "space-between",
                      paddingLeft: 5,
                      paddingRight: 5,
                      paddingBottom: 2,
                    },
                  ]}
                >
                  {row?.container_no}
                </Text>
                <Text
                  style={[
                    styles.boldText,
                    {
                      textAlign: "left",
                      paddingRight: 5,
                      paddingBottom: 2,

                      paddingLeft: 5,
                      width: "65%",
                      justifyContent: "space-between",
                    },
                  ]}
                >
                  {row?.size}
                </Text>
                <Text
                  style={[
                    styles.boldText,
                    {
                      textAlign: "left",
                      paddingRight: 5,
                      paddingBottom: 2,
                      paddingLeft: 5,
                      width: "55%",
                      borderLeft: 1,
                      justifyContent: "space-between",
                    },
                  ]}
                >
                  {row?.total_gross_weight}
                </Text>
                <Text
                  style={[
                    styles.boldText,
                    {
                      textAlign: "left",
                      paddingRight: 5,
                      paddingBottom: 2,

                      paddingLeft: 5,
                      width: "60%",
                      justifyContent: "space-between",
                      borderLeft: 1,
                    },
                  ]}
                >
                  {staticData.vgm_wt}
                </Text>
                <Text
                  style={[
                    styles.boldText,
                    {
                      borderLeft: 1,
                      textAlign: "left",
                      paddingRight: 5,
                      paddingBottom: 2,

                      paddingLeft: 5,
                      width: "50%",
                      justifyContent: "space-between",
                    },
                  ]}
                >
                  06/01/2025
                </Text>
                <Text
                  style={[
                    styles.boldText,
                    {
                      borderLeft: 1,
                      textAlign: "left",
                      paddingRight: 5,
                      paddingBottom: 2,

                      paddingLeft: 5,
                      width: "50%",
                      justifyContent: "space-between",
                    },
                  ]}
                >
                  {staticData.wt_slip_no}
                </Text>
              </View>
            </View>
          );
        })}
        <View
          style={[styles.tableContainer, { paddingLeft: 25, paddingRight: 25 }]}
        >
          <Text style={[styles.subContent, styles.boldText]}>
            We hereby confirm and certify that the Weights mentioned for the
            containers given in VGM Declaration is as per amendments to
            Regulation 2 of Chapter VI of the SOLAS convention issued by D G
            Shipping date 11th May 2016 F. No. 75-NT (4)/ 2015, M.S. Notice No
          </Text>
        </View>

        <View wrap={false}>
          <View
            style={[
              styles.tableContainer,
              { paddingLeft: 350, paddingRight: 5 },
            ]}
          >
            <Text style={[styles.subContent, styles.boldText]}>
              Name: {""}
              {stringToUpperCase(settingsData?.name_of_proprietor)}
            </Text>
          </View>

          <View
            style={[
              styles.tableContainer,
              { marginTop: 5, paddingLeft: 395, paddingRight: 5 },
            ]}
          >
            <Text style={[styles.subContent, styles.boldText]}>
              DATE: {formatDate(salesInvoiceData?.invoice_date)}
            </Text>
            <View style={[{ paddingTop: 5 }]}>
              {includeSignature && settingsData?.invoice_digital_signature ? (
                <Image
                  src={settingsData.invoice_digital_signature}
                  style={styles.logo}
                />
              ) : (
                <View style={styles.logo}></View>
              )}
            </View>
          </View>
        </View>

        <View style={[styles.footer]} fixed>
          <Text style={{ fontWeight: "bold" }}>
            {stringToUpperCase(settingsData?.company_name)}
          </Text>
          <Text style={[styles.textBlock]}>
            {stringToUpperCase(settingsData?.company_address)}
          </Text>
          <View style={styles.footerInline}>
            <Text style={[styles.textBlock]}>
              <Text style={{ fontWeight: "bold" }}>Email : </Text>
              {stringToUpperCase(settingsData?.company_email)}
            </Text>
            <Text style={[styles.textBlock, { marginLeft: 5 }]}>
              <Text style={{ fontWeight: "bold" }}>Phone No. : </Text>
              {stringToUpperCase(settingsData?.company_phone_1)} /{" "}
              {stringToUpperCase(settingsData?.company_phone_2)}
            </Text>
          </View>
          <View style={styles.footerInline}>
            <Text style={[styles.textBlock]}>
              <Text style={{ fontWeight: "bold" }}>Subject : </Text>
              Subject
            </Text>
            <Text style={[styles.textBlock, { marginLeft: 5 }]}>
              <Text style={{ fontWeight: "bold" }}>GSTIN No. : </Text>
              {stringToUpperCase(settingsData?.company_gst_no)}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};
export default VgmCertificate;
